import { render } from "./MMNewsList.vue?vue&type=template&id=5e903928"
import script from "./MMNewsList.vue?vue&type=script&lang=js"
export * from "./MMNewsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__